import React, { useEffect, useState } from "react";
import ProfileCard from "../../../ui/usersUi/profileCardUi";
import TabsExample from "../../../ui/usersUi/Tap";
import { GetUserByIdData } from "../../../lib/data";
import { useParams } from "react-router-dom";

export default function UserDetails () {

    const {userId} = useParams();
    const [userData, setUserData] = useState({});
    
    useEffect(() => {
        handleApi();
    }, [])

    const handleApi = async () => {
        const userData = await GetUserByIdData(userId);
        setUserData({})
        setUserData(userData);
    };

    const reload = async () => {
        const userData = await GetUserByIdData(userId);
        setUserData({})
        setUserData(userData);
    };

    return(
        <div className=" w-full flex flex-row">
            <div className="w-[68%] py-8 sm:py-6 md:py-8 ">
                <TabsExample />
            </div>
            <div className="w-[38%] py-8 sm:py-6 md:py-8 pe-8">
                <ProfileCard userData={userData} reload={reload} />
            </div>
        </div>
    );
};